import moment from 'moment';
import type { FormData } from '@this/components/admin/online_applications/shared/types';

const EXIC_OPTION_PLAN_ID = '7';
const I18N_OPTION_PLAN_ID = '10';

export const OPTION_ADD_CONTRACT_TERMS_TEMPLATE =
  '本書の申込日をもって合意が成立し、この合意は {existing_contract_date}に締結した「 AITravel出張手配・管理システム利用約款」および付属する申込書の内容（以下、「本契約」）を修正する。弊社は、貴社に対し、開始希望月から上記オプションを提供するものとし、貴社は、弊社に対し、上記オプション利用の対価として、本書により定めた金額を、本契約により生ずる金額に加えて支払うものとする。本オプションに関する初回の支払日は、弊社が貴社に対し{first_payment_year_month}に提示する予定の請求書類にしたがい支払うものとする。';

export const EXIC_OPTION_TERMS =
  '上記月額固定のオプション料金に加え、EX-ICの利用料金額に対して2％のサポート手数料が従量制で発生するもとする。貴社は、弊社が2023年4月に改正された消費税法等の一部の改正による適格請求書等保存方式（インボイス制度）に対応することを目的として、本申込書に基づき、弊社が貴社に対して発行する請求書及びその明細について、AI Travel利用約款に定める守秘義務と同等の義務を課した第三者に対し、提供することを認める。';

export const ENGLISH_TRANSLATION_OPTION_TERMS =
  '「AI Travel」上で表示される日本語を除く言語については、参考として作成されたもので、言語によって解釈に相違がある場合には、日本語版を正文として優先する。';

interface OptionAddTermsParams {
  existingContractDate?: string;
  firstPaymentYear?: number;
  firstPaymentMonth?: number;
  optionPlanIds: string[];
}

const buildTermsFromParams = (params: OptionAddTermsParams): string => {
  const existingContractDate = params.existingContractDate
    ? moment(params.existingContractDate).format('YYYY年M月D日')
    : '';

  const firstPaymentYearMonth =
    params.firstPaymentYear && params.firstPaymentMonth
      ? `${params.firstPaymentYear}年${params.firstPaymentMonth}月`
      : '';

  let text = OPTION_ADD_CONTRACT_TERMS_TEMPLATE.replace('{existing_contract_date}', existingContractDate).replace(
    '{first_payment_year_month}',
    firstPaymentYearMonth
  );

  const OPTION_TERMS_MAP: Record<string, string> = {
    [EXIC_OPTION_PLAN_ID]: EXIC_OPTION_TERMS,
    [I18N_OPTION_PLAN_ID]: ENGLISH_TRANSLATION_OPTION_TERMS
  };

  params.optionPlanIds.forEach(optionPlanId => {
    const terms = OPTION_TERMS_MAP[optionPlanId];
    if (terms) {
      text += '\n\n' + terms;
    }
  });

  return text;
};

/**
 * 編集フォーム（FormData）から契約条件テキストを生成する
 */
export const buildOptionAddContractTerms = (formData: FormData): string => {
  return buildTermsFromParams({
    existingContractDate: formData.existingContractDate,
    firstPaymentYear: formData.firstPaymentYear,
    firstPaymentMonth: formData.firstPaymentMonth,
    optionPlanIds: (formData.dynamicOptions || []).map(opt => opt.optionId)
  });
};

/**
 * ドメインモデル（OnlineApplication）から契約条件テキストを生成する
 */
export const buildOptionAddContractTermsFromApplication = (application: {
  existingContractDate?: string;
  firstPaymentYear?: number;
  firstPaymentMonth?: number;
  options?: { option_plan_id?: number; option_id?: string }[];
}): string => {
  return buildTermsFromParams({
    existingContractDate: application.existingContractDate,
    firstPaymentYear: application.firstPaymentYear,
    firstPaymentMonth: application.firstPaymentMonth,
    optionPlanIds: (application.options || []).map(opt => String(opt.option_plan_id || opt.option_id || ''))
  });
};
